import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const FancyHighlight = ({ sx, ...rest }: BoxProps) => {
	return (
		<Box
			component="span"
			sx={combineSx(
				({ vars, borderRadius }) => ({
					paddingY: 50,
					paddingX: 100,
					backgroundColor: vars.palette.uc.highlight.bg.main,
					border: 'solid 1px',
					borderColor: vars.palette.uc.highlight.border.weak,
					borderRadius: borderRadius.roundedXS,
				}),
				sx,
			)}
			{...rest}
		/>
	);
};

export default FancyHighlight;
